module.exports = __webpack_public_path__ + "media/images/sort_desc-1fc418e33fd5a687290258b23fac4e98.png";